var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:[_vm.colorTheme, _vm.calcedBgColor]},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c('Nav',{attrs:{"color-theme":_vm.colorTheme,"bg-color":_vm.bgColor,"calced-bg-color":_vm.calcedBgColor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }